import * as React from 'react';
import styled from 'styled-components';
import { StyledInformationalPage } from '../../../common/static.styles';
import { HeadTitle } from '../../../components/head-title/HeadTitle';
import { TranslatedPath } from '../../../components/navigation/language-switcher/LanguageSwitcher.props';
import { DefaultLayout } from '../../../layout/default/DefaultLayout';

// TODO: Add SEO props
const seo = {
  description: '',
};

const StyledFAQPage = styled(StyledInformationalPage)`
  .faq-field:not(:last-of-type) {
    margin-bottom: 3.75em;
  }

  .faq-field-question {
    text-transform: none;
    font-size: 1rem;
    line-height: 1rem;
  }

  .faq-field-answer {
    font-size: 1rem;
  }

  .faq-field-list {
    list-style: disc;
    padding: 0 1rem 0 2rem;
  }

  .faq-field-list-item {
    word-wrap: break-word;
  }
`;

const translatedPaths: TranslatedPath[] = [{ locale: 'nl-BE', path: '/help' }];

const title = 'FAQ Générale';

// tslint:disable:max-line-length
// noinspection JSUnusedGlobalSymbols
export default () => (
  <DefaultLayout locale='fr-BE' seo={seo} translatedPaths={translatedPaths}>
    <HeadTitle title={title} />
    <StyledFAQPage>
      <div className='content'>
        <section>
          <h1>{title}</h1>
          <div className='faq-field'>
            <h2 className='faq-field-question'>Qui est WarnerBros.be?</h2>
            <div className='faq-field-answer'>
              <p>
                <a href='https://www.warnerbros.be' target='_blank'>
                  WarnerBros.be
                </a>{' '}
                est un site sur lequel vous retrouverez toutes les informations sur Warner Bros. Cinéma, Vidéo, Jeux
                Vidéo et plus!
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>Puis-je participer à une première?</h2>
            <div className='faq-field-answer'>
              <p>
                Les premières sont seulement accessibles sur invitation personnelle. Mais des places sont souvent
                proposés grâce à des concours sur le site ou les réseaux sociaux.
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>Où puis-je acheter des billets pour le Warner Bros. Studio Tour?</h2>
            <div className='faq-field-answer'>
              <p>
                On peut visiter les Studios de Warner Bros. ! Visitez le site officiel de Warner Bros. Studio Tour
                Hollywood sur{' '}
                <a href='http://www.wbstudiotour.com' target='_blank'>
                  www.wbstudiotour.com
                </a>{' '}
                ou Warner Bros. Studio Tour London sur{' '}
                <a href='http://www.wbstudiotour.co.uk' target='_blank'>
                  www.wbstudiotour.co.uk
                </a>{' '}
                pour plus d'informations.
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>Travailler à la Warner?</h2>
            <div className='faq-field-answer'>
              <p>
                Pour une liste complète des postes vacants, visitez le site:{' '}
                <a href='https://www.warnerbroscareers.com' target='_blank'>
                  www.warnerbroscareers.com
                </a>
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>
              J'ai une idée de film, de série télé ou de scénario. Comment contacter Warner Bros.?
            </h2>
            <div className='faq-field-answer'>
              <p>
                Warner Bros. Entertainment ne reçoit pas d'idées de film, série télé ou autre matériel, sauf si ceux-ci
                sont envoyés par un agent littéraire certifié et faisant partie du Writers Guild Of America. Si vous
                êtes intéressé par la liste d'agents accrédités, merci d'appeler le Writers Guild aux Etats-Unis au
                numéro 323-951-4000, ou d'envoyer un email via le site,{' '}
                <a href='http://www.wga.org/' target='_blank'>
                  www.wga.org
                </a>
                .
              </p>
            </div>
          </div>
          <div className='faq-field'>
            <h2 className='faq-field-question'>Wat is Digital HD ULTRAVIOLET?</h2>
            <div className='faq-field-answer'>
              <p>
                Visionnez votre film où vous voulez sur différents appareils! Plus d'information sur:{' '}
                <a href='https://fr.flixster.com' target='_blank'>
                  fr.flixster.com
                </a>
              </p>
            </div>
          </div>
        </section>
      </div>
    </StyledFAQPage>
  </DefaultLayout>
);
